// extracted by mini-css-extract-plugin
module.exports = {"form":"form--+w4lr","label":"label--Cp4QQ","growBox":"growBox--aYLil"};